import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ActionIconContainer, AddFormButton } from "../../../shared/components/TableElements";

const ReactivateAddonModal = ({
  show,
  onHide,
  title,
  addonName,
  addonCost,
  onConfirm,
  loading,
  error,
}) => {
  const { t } = useTranslation("common");

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header>
        <h4>{title}</h4>
        <div className="d-flex justify-content-end">
          <ActionIconContainer onClick={onHide}>
            <i className="fi fi-rr-cross-small" />
          </ActionIconContainer>
        </div>
      </Modal.Header>
      <Modal.Body>
        <BodyText>{t("reactivate_addon_message", { addonName })}</BodyText>

        <InfoRow>
          <RowLabel>{t("addon_cost")}</RowLabel>
          <RowValue style={{ fontWeight: 700 }}>{addonCost}</RowValue>
        </InfoRow>

        {error && <ErrorText>{error}</ErrorText>}
      </Modal.Body>
      <ModalFooter>
        <AddFormButton type="button" onClick={onConfirm} disabled={loading}>
          {loading ? t("reactivating") : t("reactivate")}
        </AddFormButton>
      </ModalFooter>
    </Modal>
  );
};

export default ReactivateAddonModal;

// ── Styled components ──────────────────────────────────────────────────────

const BodyText = styled.p`
  font-size: 14px;
  color: #374151;
  margin-bottom: 20px;
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-top: 1px solid #e5e7eb;
`;

const RowLabel = styled.span`
  font-size: 14px;
  //color: #6b7280;
`;

const RowValue = styled.span`
  font-size: 14px;
`;

const ModalFooter = styled(Modal.Footer)`
  border-top: none;
  justify-content: flex-end;
`;

const ReactivateBtn = styled.button`
  padding: 8px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  background: #1f2937;
  color: #ffffff;
  cursor: pointer;
  font-family: inherit;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const ErrorText = styled.div`
  font-size: 13px;
  color: #ef4444;
  margin-top: 8px;
`;